/**
 * List of supported languages in B24.Cloud
 *
 * It is worth remembering that there will be 1-2 languages for the B24.Box
 */
export enum B24LangList {
	en = 'en',
	de = 'de',
	la = 'la',

	br = 'br',
	fr = 'fr',
	it = 'it',

	pl = 'pl',
	ru = 'ru',
	ua = 'ua',

	tr = 'tr',
	sc = 'sc',
	tc = 'tc',

	ja = 'ja',
	vn = 'vn',
	id = 'id',

	ms = 'ms',
	th = 'th',
	ar = 'ar',
}
